import { RejectCandidateFormData } from "./rejectCandidateFormData";

export class RejectCandidate {
    reason: number;
    details: string;
    dnr?: boolean;
    hiredEndDate?: Date;
    isBookingCreditRequested?: boolean;

    private constructor(formData: RejectCandidateFormData) {
        this.reason = formData.reason;
        this.details = formData.details;
        this.dnr = formData.dnr;
        this.hiredEndDate = formData.hiredEndDate;
        this.isBookingCreditRequested = formData.isBookingCreditRequested;
    }

    static create = (formData: RejectCandidateFormData): RejectCandidate =>
        new RejectCandidate(formData);
}
